import International from "../components/events/International";

export default function EventPage1 () {

    return (
        <>
        <International/>
        </>
    )
}